






































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import BinDetail from "../../../store/entities/bindetail";
import Bin from "../../../store/entities/bin";
import DateTimeMixin from '@/components/mixin/date-time-mixin';
import { mixins } from 'vue-class-component';

@Component
export default class ViewBin extends mixins(DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  bin: BinDetail = new BinDetail();
  title: string = "";
  cancel() {
    (this.$refs.viewBinForm as any).resetFields();
    this.$store.state.bin.viewBin = new Bin();
    this.$emit("input", false);
  }
  created() {}
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      const viewBin = Util.extend(true, {}, this.$store.state.bin.viewBin);
      this.$store
        .dispatch({
          type: "bin/get",
          data: { id: viewBin.id }
        })
        .then(result => {
          this.bin = result;
          this.title = Util.L("ViewBin") + "-" + this.bin.code;
        });
    }
  }
}
